import { useRef } from 'react';
import ReactDom from 'react-dom';
import { components } from 'react-select';
// eslint-disable-next-line import/no-unresolved
import { MenuPortalProps } from 'react-select/dist/declarations/src/components/Menu';
import { CSSTransition } from 'react-transition-group';

import { useTabletOrWider } from '@utils/mediaQuery';

import { GroupBase } from '../../types';

import s from './MenuPortalMobileBottom.sss';

const Component = components.MenuPortal;

export function MenuPortalMobileBottom<
Option,
IsMulti extends boolean = false,
Group extends GroupBase<Option> = GroupBase<Option>,
>(props: MenuPortalProps<Option, IsMulti, Group>) {
  const isTabletOrWider = useTabletOrWider();
  const portalRef = useRef(null);

  // For wide table or desktops return native MenuPortal
  if (isTabletOrWider) {
    return (
      <Component {...props}>
        {props.children}
      </Component>
    );
  }

  // For mobile or narrow tablets return custom portal
  const CustomMenu = (
    <CSSTransition
      in={true}
      appear={true}
      timeout={300}
      classNames={{
        appear: s.appear,
        appearActive: s.appearActive,
      }}
    >
      {/* Prevent Select closing when click event bubbling to portal */}
      <div
        ref={portalRef}
        className={s.mobilePortal}
        onMouseDown={(e) => e.target !== portalRef.current && e.preventDefault()}
        onTouchEnd={(e) => e.target === portalRef.current && e.preventDefault()}
        onClick={() => (document.activeElement as HTMLElement).blur()}
        role="button"
        tabIndex={0}
        onKeyPress={() => (document.activeElement as HTMLElement).blur()}
      >
        {props.children}
      </div>
    </CSSTransition>
  );

  return ReactDom.createPortal(
    CustomMenu,
    document.body,
  );
}
